import { createSelector } from 'reselect'

export default createSelector(
	[ state => state.matchingPairsCt.timer ],
	timer => timer
)
